import { InventoryController, WalletController } from '../../controllers';
import { appStore, inventoryStore, userStore } from '../../stores';
import { MimaToastUtil } from '../../components';
import { useFileUpload } from 'use-file-upload';
import constant from '../../utils/constant';
import { EditModal } from '../../pages';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const EditModalContainer = ({ closeModal, goBack, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);
	const [fileOne, selectOneFile] = useFileUpload();
	const [fileTwo, selectTwoFile] = useFileUpload();
	const [fileThree, selectThreeFile] = useFileUpload();
	const [accountName, setAccountName] = useState('');

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.STOCKEDITPRODUCTTYPE);

	const selectOneClick = () => {
		selectOneFile({ accept: 'image/*' });
	};
	const selectTwoClick = () => {
		selectTwoFile({ accept: 'image/*' });
	};
	const selectThreeClick = () => {
		selectThreeFile({ accept: 'image/*' });
	};

	const validationSchema = () => {
		return yup.object({
			name: yup.string().required('name is required'),
			type: yup.string().required('type is required'),
			unitOfMeasurement: yup
				.string()
				.required('Unit Of Measurement is required'),
		});
	};
	const fileReader = async (file, field, values) => {
		if (file && typeof file.source === 'string') {
			const fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
			values[field] = fileToSend;
		}
	};
	const verifyAccountNumber = async payload => {
		if (
			payload.beneficiaryBank &&
			payload.accountNumber &&
			payload.accountNumber.length === 10
		) {
			const { status, data, errorMessage } =
				await WalletController.verifyAccountNumber(payload);
			if (status === constant.Success) {
				return data.accountName;
			} else {
				MimaToastUtil.error({
					message: errorMessage,
				});
			}
		}
		return '';
	};
	const onSubmit = async payload => {
		setLoading(true);
		const fdata = new FormData();
		delete payload.split;
		payload.accountName = accountName || payload.accountName;
		if (fileOne && fileOne.source)
			await fileReader(fileOne, 'imageOne', payload);
		if (fileTwo && fileTwo.source)
			await fileReader(fileTwo, 'imageTwo', payload);
		if (fileThree && fileThree.source)
			await fileReader(fileThree, 'imageThree', payload);

		delete payload.hasImages;
		delete payload.hasMulticurrency;
		delete payload.productType;

		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			} else {
				fdata.append(key, payload[key]);
			}
		}

		const { status, errorMessage } =
			await InventoryController.updateProduct(
				fdata,
				inventoryStore.selectedProduct?._id
			);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<EditModal
			closeModal={closeModal}
			goBack={goBack}
			loading={loading}
			selectOneClick={selectOneClick}
			selectTwoClick={selectTwoClick}
			selectThreeClick={selectThreeClick}
			fileOne={fileOne}
			fileTwo={fileTwo}
			fileThree={fileThree}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			accountName={accountName}
			setAccountName={setAccountName}
			setLoading={setLoading}
			verifyAccountNumber={verifyAccountNumber}
			banks={appStore.banks.map(bank => {
				return { id: bank.key, value: bank.value };
			})}
		/>
	);
};
export default observer(EditModalContainer);
